<template>
  <div class="example">
    <span class="cr-sample" @mouseenter="isHover = true" @mouseleave="isHover = false">
      <img :src="url" />
      <span class="cr-sams cr-bg-primary cr-text-white-1">示例</span>
      <div class="mask" v-if="isHover" @click="onPreview">查看大图</div>
    </span>
    <preview-img :url="url" :show.sync="showPreview"></preview-img>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPreview: false,
      isHover: false
    }
  },
  methods: {
    onPreview() {
      this.showPreview = true
    }
  }
}
</script>

<style lang="less" scoped>
.example {
  display: inline-block;
  width: 160px;
  height: 120px;
}
.cr-sample {
  position: relative;
  display: inline-block;
  width: 160px;
  height: 120px;
  border-radius: 2px;
  border: 1px solid #eeeeee;
  padding: 4px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .cr-sams {
    border-radius: 0px 2px 0px 0px;
    position: absolute;
    top: 0;
    right: 0;
    width: 52px;
    height: 22px;
    line-height: 22px;
    text-align: center;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }
}
</style>
